import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
  NotificationService,
  I18nService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteEventPlanningDocument,
  DeleteEventPlanningMutation,
} from "src/generated-gql/graphql";

const deleteBulkAction: BulkAction = {
  location: "event-planning-table",
  label: "event.delete-selected-event-planning",
  icon: "warning",
  iconClass: "is-warning",
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    const translator = injector.get(I18nService);

    modalService
      .dialog({
        title: translator.translate("event.delete-selected-event-planning"),
        body: translator.translate("event.delete-event-planning-content", {
          selection: selection.length,
        }),
        buttons: [
          { type: "secondary", label: translator.translate("common.cancel") },
          {
            type: "primary",
            label: translator.translate("common.delete"),
            returnValue: selection,
          },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteEventPlanningMutation>[] =
            [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteEventPlanningDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe((res) => {
            if (res && res.length > 0) {
              notificationService.success(
                translator.translate(
                  "common.notify-delete-success-with-count",
                  {
                    count: res.length,
                  }
                )
              );
            }
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
